import { CompanyWithSitesMinifiedType as ApiCompanyWithSitesMinifiedType } from 'src/api/generated/touring/types';
import { mapCompanySitesMinified } from './helpers';
import { CompanyWithSitesMinifiedRowType } from './types';

export const mapCompanySitesMinifiedType = (
  apiType: ApiCompanyWithSitesMinifiedType[] | undefined
): CompanyWithSitesMinifiedRowType[] => {
  if (!apiType) return [];

  return apiType.map((company) => ({
    id: company.id,
    name: company.name,
    sites: mapCompanySitesMinified(company.sites),
  }));
};
